module.exports = __webpack_public_path__ + "img/597C3F_254319_6C9668_7C9B53-256px.9bbc730a.png";